export * from "@root/lib/utils/go-up";
